import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ContentProvider } from "./lib/ContentContext";
import Landing from "./pages/Landing";
import GuestPanel from "./pages/GuestPanel";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import Reality from "./pages/Reality";
import "./App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    // Elegant document title
    document.title = "Casa Alta · O Reality — Alta Agency";
  }, []);

  return (
    <div className="App min-h-screen bg-[#F9F8F6] text-neutral-900">
      <ContentProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Reality />} />
            <Route path="/evento" element={<Landing />} />
            <Route path="/convidado" element={<GuestPanel />} />
            <Route path="/reality" element={<Navigate to="/" replace />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1A1A1A",
            color: "#F9F8F6",
            border: "1px solid #1A1A1A",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
            fontSize: "13px",
            letterSpacing: "0.04em",
          },
        }}
      />
    </div>
  );
}

export default App;
